import styled from "styled-components";

export const Step = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr clamp(60px, 7vw, 128px) 1fr;
  grid-template-areas: 'img line text';

  ${({ theme }) => theme.old.breakpoints.isTab} {
    grid-template-columns: unset;
    grid-template-rows: repeat(3, auto);
    grid-template-areas: '. text .' '. img .' '. line .';
  }
`